export function buildConsultationJson(paramsObj) {
    let clientNamesArr = [];

    try {
        clientNamesArr = paramsObj.client_names;
    } catch(err) {
        // do nothing
    }

    const json = {
      "title": "Contraindication + Regimen Forms",
      "logoPosition": "right",
      "completedHtml": "<h3>Thank you for completing the consultation form.</h3>",
      "completedHtmlOnCondition": [
        {
          "expression": "((({allergies} = 'Y') or ({metal_implants} = 'item1')) or ({pregnancy} = 'item1')) or notempty {current_treatments}",
          "html": "A CONTRAINDICATION HAS BEEN RECORDED. PLEASE CONSULT WITH YOUR SKIN THERAPIST."
        }
      ],
      "loadingHtml": "<h3>Loading consultation form...</h3>",
      "pages": [
        {
          "name": "page 1",
          "elements": [
            {
              "type": "panel",
              "name": "Contraindication_Consultation",
              "title": "Consultation",
              "elements": [
                {
                  "type": "panel",
                  "name": "panel1",
                  "showQuestionNumbers": "off",
                  "elements": [
                    {
                      "type": "radiogroup",
                      "name": "new-or-returning",
                      "title": "New client or returning client?",
                      "isRequired": true,
                      "choices": [
                        {
                          "value": "new_client",
                          "text": "New"
                        },
                        {
                          "value": "returning_client",
                          "text": "Returning"
                        }
                      ]
                    },
                    {
                      "type": "dropdown",
                      "name": "clientlookup",
                      "visibleIf": "{new-or-returning} = 'returning_client'",
                      "title": "Client lookup",
                      "requiredIf": "{new-or-returning} = 'returning_client'",
                      "choices": clientNamesArr
                    }
                  ]
                },
                {
                  "type": "panel",
                  "name": "client_details",
                  "visibleIf": "{new-or-returning} = 'new_client'",
                  "minWidth": "200px",
                  "showQuestionNumbers": "off",
                  "elements": [
                    {
                      "type": "text",
                      "name": "first_name",
                      "minWidth": "200px",
                      "title": "First Name",
                      "isRequired": true
                    },
                    {
                      "type": "text",
                      "name": "last_name",
                      "minWidth": "200px",
                      "startWithNewLine": false,
                      "title": "Last Name",
                      "hideNumber": true
                    },
                    {
                      "type": "text",
                      "name": "email",
                      "minWidth": "200px",
                      "startWithNewLine": false,
                      "title": "Email Address",
                      "isRequired": true,
                      "inputType": "email"
                    },
                    {
                      "type": "text",
                      "name": "birthdate",
                      "startWithNewLine": false,
                      "title": "Birth Date",
                      "inputType": "date",
                      "autocomplete": "bday"
                    }
                  ]
                },
                {
                  "type": "radiogroup",
                  "name": "allergies",
                  "title": "Within the last year, have you been under a physician’s care on medication or experienced any health problems including allergies?",
                  "isRequired": true,
                  "validators": [
                    {
                      "type": "expression"
                    }
                  ],
                  "choices": [
                    "Yes",
                    "No"
                  ]
                },
                {
                  "type": "comment",
                  "name": "allergies_desc",
                  "visibleIf": "{allergies} = 'Yes'",
                  "minWidth": "200px",
                  "title": "If yes, please explain:",
                  "hideNumber": true,
                  "enableIf": "{allergies} = 'Yes'",
                  "requiredIf": "{allergies} = 'Yes'"
                },
                {
                  "type": "radiogroup",
                  "name": "metal_implants",
                  "minWidth": "200px",
                  "title": "Do you have metal implants, a pacemaker or body piercings?",
                  "isRequired": true,
                  "choices": [
                    "Yes",
                    "No"
                  ]
                },
                {
                  "type": "radiogroup",
                  "name": "pregnancy",
                  "minWidth": "200px",
                  "title": "Are you pregnant, trying to become pregnant or lactating?",
                  "isRequired": true,
                  "choices": [
                    "Yes",
                    "No"
                  ]
                },
                {
                  "type": "checkbox",
                  "name": "current_treatments",
                  "minWidth": "200px",
                  "title": "Are you currently using any of the products or receiving any of the treatments below?",
                  "choices": [
                    "exfoliating products",
                    "vitamin A derivatives (such as Retinol)",
                    "wax (within the last 72 hours)",
                    "laser or light therapy (within the last month)",
                    "chemical peel (within the last month)chemical peel (within the last month)",
                    "microdermabrasion (within the last month)"
                  ]
                },
                {
                  "type": "comment",
                  "name": "notes",
                  "minWidth": "200px",
                  "title": "notes:",
                  "hideNumber": true
                },
                {
                  "type": "signaturepad",
                  "name": "signature",
                  "minWidth": "200px",
                  "title": "I certify that the information I have provided on this consultation is accurate, to the best of my knowledge, and that I have not withheld any information that will be relevant to my treatment.",
                  "hideNumber": true,
                  "isRequired": true,
                  "signatureWidth": 500,
                  "signatureAutoScaleEnabled": true,
                  "penColor": "#5e93db"
                },
                {
                  "type": "checkbox",
                  "name": "consent-data-sharing",
                  "minWidth": "200px",
                  "title": "Consent to share your Data with Face Mapping PRO.",
                  "hideNumber": true,
                  "isRequired": true,
                  "requiredErrorText": "You must consent to Dermalogica, LLC processing your information to provide this app's service.",
                  "choices": [
                    {
                      "value": "data_consent",
                      "text": "I consent to Dermalogica, LLC processing my information to provide the app service to me. Additionally, I consent for this store to view and modify data related to my skin consultations and treatments done at this store."
                    }
                  ]
                },
                {
                  "type": "checkbox",
                  "name": "consent-emails",
                  "minWidth": "200px",
                  "title": "Manage my Data Sharing with Face Mapping PRO.",
                  "hideNumber": true,
                  "choices": [
                    {
                      "value": "advice_consent",
                      "text": "I consent to receiving prescription and aftercare advice. These are one-time emails that only get sent after my skin consultations and treatments."
                    },
                    {
                      "value": "subscribe_consent",
                      "text": "Subscribe to news and promotional email notifications from this store. These include periodic promotional communications regarding new products and treatments."
                    },
                    {
                      "value": "connect_customer",
                      "text": "Connect Customer"
                    },
                    {
                      "value": "customer_survey",
                      "text": "Customer Survey"
                    }
                  ],
                  "selectAllText": "Consent to All"
                }
              ]
            },
            {
              "type": "html",
              "name": "dermalogica_privacy_policy",
              "minWidth": "200px",
              "hideNumber": true,
              "html": "<p><em>Dermalogica takes privacy seriously. For a full discussion of our privacy policy, please visit dermalogica.com and click the link Privacy Policy. The following five principles underpin our approach to respecting your privacy when Dermalogica collects your information.</em></p>\n<ol>\n<li><em>We value the trust that you place in us by giving us your personal information. We will always use your personal information in a way that is fair and worthy of that trust.</em></li>\n<li><em>You are entitled to clear information about how we use your personal information. We shall always be transparent with you about what information we collect, what we do with it, with whom we share it and whom you should contact if you have any concerns.</em></li>\n<li><em>If you have any concerns about how we use your personal information, we will work with you to promptly resolve those concerns.</em></li>\n<li><em>We will take all reasonable steps to protect your information from misuse and keep it secure.</em></li>\n<li><em>We will comply with all applicable data protection laws and regulations and we will co-operate with data protection authorities. In the absence of data protection legislation, we will act in accordance with generally accepted principles governing data protection.</em></li>\n</ol>\n<p><em>If you have any questions, please use the <a href=\"https://www.dermalogica.com/pages/contact-us\" target=\"_blank\">Contact Us</a> function at dermalogica.com. When others collect your information, their policies may differ from Dermalogica&rsquo;s.</em></p>"
            },
            {
              "type": "paneldynamic",
              "name": "regimen_panel",
              "title": "My Regimen",
              "titleLocation": "top",
              "hideNumber": true,
              "templateElements": [
                {
                  "type": "dropdown",
                  "name": "product_name",
                  "title": "product",
                  "titleLocation": "left",
                  "choices": [
                    {
                      "value": "active_clay_cleanser",
                      "text": "active clay cleanser"
                    },
                    {
                      "value": "active_moist_moisturizer",
                      "text": "active moist moisturizer"
                    },
                    {
                      "value": "age_bright_clearing_serum",
                      "text": "age bright clearing serum"
                    },
                    {
                      "value": "age_bright_spot_fader",
                      "text": "age bright spot fader"
                    },
                    {
                      "value": "age_defense_kit",
                      "text": "age defense kit"
                    },
                    {
                      "value": "age_reversal_eye_complex",
                      "text": "age reversal eye complex"
                    },
                    {
                      "value": "antioxidant_hydramist_toner",
                      "text": "antioxidant hydramist toner"
                    },
                    {
                      "value": "awaken_peptide_eye_gel",
                      "text": "awaken peptide eye gel"
                    },
                    {
                      "value": "barrier_repair_serum",
                      "text": "barrier repair serum"
                    },
                    {
                      "value": "biolumin-c_eye_serum",
                      "text": "biolumin-c eye serum"
                    },
                    {
                      "value": "biolumin-c_gel_moisturizer",
                      "text": "biolumin-c gel moisturizer"
                    },
                    {
                      "value": "biolumin-c_serum",
                      "text": "biolumin-c serum"
                    },
                    {
                      "value": "blackhead_clearing_fizz_mask",
                      "text": "blackhead clearing fizz mask"
                    },
                    {
                      "value": "body_hydrating_cream",
                      "text": "body hydrating cream"
                    },
                    {
                      "value": "breakout_clearing_booster",
                      "text": "breakout clearing booster"
                    },
                    {
                      "value": "breakout_clearing_kit",
                      "text": "breakout clearing kit"
                    },
                    {
                      "value": "breakout_clearing_liquid_peel",
                      "text": "breakout clearing liquid peel"
                    },
                    {
                      "value": "brightening_biolumin-c_trio_kit",
                      "text": "brightening biolumin-c trio kit"
                    },
                    {
                      "value": "calm_water_gel_moisturizer",
                      "text": "calm water gel moisturizer"
                    },
                    {
                      "value": "charcoal_rescue_masque",
                      "text": "charcoal rescue masque"
                    },
                    {
                      "value": "circular_hydration_serum",
                      "text": "circular hydration serum"
                    },
                    {
                      "value": "clear_+_brighten_power_duo_kit",
                      "text": "clear + brighten power duo kit"
                    },
                    {
                      "value": "clear_and_brighten_kit",
                      "text": "clear and brighten kit"
                    },
                    {
                      "value": "clearing_defense_spf30",
                      "text": "clearing defense spf30"
                    },
                    {
                      "value": "clearing_skin_wash_cleanser",
                      "text": "clearing skin wash cleanser"
                    },
                    {
                      "value": "conditioning_body_wash",
                      "text": "conditioning body wash"
                    },
                    {
                      "value": "cooling_aqua_jelly_moisturizer",
                      "text": "cooling aqua jelly moisturizer"
                    },
                    {
                      "value": "daily_brightness_boosters_kit",
                      "text": "daily brightness boosters kit"
                    },
                    {
                      "value": "daily_glycolic_cleanser",
                      "text": "daily glycolic cleanser"
                    },
                    {
                      "value": "daily_microfoliant_exfoliator",
                      "text": "daily microfoliant exfoliator"
                    },
                    {
                      "value": "daily_milkfoliant_exfoliator",
                      "text": "daily milkfoliant exfoliator"
                    },
                    {
                      "value": "daily_superfoliant_exfoliator",
                      "text": "daily superfoliant exfoliator"
                    },
                    {
                      "value": "dark_spot_solutions_kit",
                      "text": "dark spot solutions kit"
                    },
                    {
                      "value": "discover_healthy_skin_kit",
                      "text": "discover healthy skin kit"
                    },
                    {
                      "value": "double_cleanse_+_go_kit",
                      "text": "double cleanse + go kit"
                    },
                    {
                      "value": "double_cleanse_full_size_kit",
                      "text": "double cleanse full size kit"
                    },
                    {
                      "value": "dynamic_skin_recovery_spf50_moisturizer",
                      "text": "dynamic skin recovery spf50 moisturizer"
                    },
                    {
                      "value": "hyaluronic_ceramide_mist_toner",
                      "text": "hyaluronic ceramide mist toner"
                    },
                    {
                      "value": "hydro_masque_exfoliant",
                      "text": "hydro masque exfoliant"
                    },
                    {
                      "value": "intensive_eye_repair",
                      "text": "intensive eye repair"
                    },
                    {
                      "value": "intensive_moisture_balance_moisturizer",
                      "text": "intensive moisture balance moisturizer"
                    },
                    {
                      "value": "intensive_moisture_cleanser",
                      "text": "intensive moisture cleanser"
                    },
                    {
                      "value": "intensive_moisture_trio_kit",
                      "text": "intensive moisture trio kit"
                    },
                    {
                      "value": "invisible_physical_defense_spf30",
                      "text": "invisible physical defense spf30"
                    },
                    {
                      "value": "melting_moisture_masque",
                      "text": "melting moisture masque"
                    },
                    {
                      "value": "micro-pore_mist_toner",
                      "text": "micro-pore mist toner"
                    },
                    {
                      "value": "multi-active_toner",
                      "text": "multi-active toner"
                    },
                    {
                      "value": "multi-masque_kit",
                      "text": "multi-masque kit"
                    },
                    {
                      "value": "multivitamin_power_firm_eye_cream",
                      "text": "multivitamin power firm eye cream"
                    },
                    {
                      "value": "multivitamin_power_recovery_masque",
                      "text": "multivitamin power recovery masque"
                    },
                    {
                      "value": "multivitamin_power_serum",
                      "text": "multivitamin power serum"
                    },
                    {
                      "value": "multivitamin_thermafoliant_exfoliator",
                      "text": "multivitamin thermafoliant exfoliator"
                    },
                    {
                      "value": "neck_fit_contour_serum",
                      "text": "neck fit contour serum"
                    },
                    {
                      "value": "nightly_lip_treatment",
                      "text": "nightly lip treatment"
                    },
                    {
                      "value": "oil_free_matte_spf30",
                      "text": "oil free matte spf30"
                    },
                    {
                      "value": "overnight_repair_serum",
                      "text": "overnight repair serum"
                    },
                    {
                      "value": "overnight_retinol_repair",
                      "text": "overnight retinol repair"
                    },
                    {
                      "value": "phyto_replenish_body_oil",
                      "text": "phyto replenish body oil"
                    },
                    {
                      "value": "phyto_replenish_oil",
                      "text": "phyto replenish oil"
                    },
                    {
                      "value": "phyto-nature_firming_serum",
                      "text": "phyto-nature firming serum"
                    },
                    {
                      "value": "post-breakout_fix",
                      "text": "post-breakout fix"
                    },
                    {
                      "value": "powder_foliant_trio_kit",
                      "text": "powder foliant trio kit"
                    },
                    {
                      "value": "powerbright_dark_spot_serum",
                      "text": "powerbright dark spot serum"
                    },
                    {
                      "value": "powerbright_moisturizer_spf50",
                      "text": "powerbright moisturizer spf50"
                    },
                    {
                      "value": "powerbright_overnight_cream_moisturizer",
                      "text": "powerbright overnight cream moisturizer"
                    },
                    {
                      "value": "precleanse_cleansing_balm",
                      "text": "precleanse cleansing balm"
                    },
                    {
                      "value": "precleanse_cleansing_oil",
                      "text": "precleanse cleansing oil"
                    },
                    {
                      "value": "prisma_protect_spf30_moisturizer",
                      "text": "prisma protect spf30 moisturizer"
                    },
                    {
                      "value": "protection_50_sport_spf50",
                      "text": "protection 50 sport spf50"
                    },
                    {
                      "value": "rapid_reveal_peel",
                      "text": "rapid reveal peel"
                    },
                    {
                      "value": "redness_relief_essence",
                      "text": "redness relief essence"
                    },
                    {
                      "value": "renewal_lip_complex",
                      "text": "renewal lip complex"
                    },
                    {
                      "value": "retinol_clearing_oil",
                      "text": "retinol clearing oil"
                    },
                    {
                      "value": "sebum_clearing_masque",
                      "text": "sebum clearing masque"
                    },
                    {
                      "value": "sensitive_skin_rescue_kit",
                      "text": "sensitive skin rescue kit"
                    },
                    {
                      "value": "sheer_tint_spf20",
                      "text": "sheer tint spf20"
                    },
                    {
                      "value": "skin_hydrating_booster",
                      "text": "skin hydrating booster"
                    },
                    {
                      "value": "skin_hydrating_masque",
                      "text": "skin hydrating masque"
                    },
                    {
                      "value": "skin_resurfacing_cleanser",
                      "text": "skin resurfacing cleanser"
                    },
                    {
                      "value": "skin_smoothing_cream_moisturizer",
                      "text": "skin smoothing cream moisturizer"
                    },
                    {
                      "value": "skin_soothing_hydrating_lotion_moisturizer",
                      "text": "skin soothing hydrating lotion moisturizer"
                    },
                    {
                      "value": "skinperfect_primer_spf30",
                      "text": "skinperfect primer spf30"
                    },
                    {
                      "value": "smart_response_serum",
                      "text": "smart response serum"
                    },
                    {
                      "value": "sound_sleep_cocoon_moisturizer",
                      "text": "sound sleep cocoon moisturizer"
                    },
                    {
                      "value": "special_cleansing_gel_cleanser",
                      "text": "special cleansing gel cleanser"
                    },
                    {
                      "value": "stress_positive_eye_lift_mask",
                      "text": "stress positive eye lift mask"
                    },
                    {
                      "value": "super_rich_repair_moisturizer",
                      "text": "super rich repair moisturizer"
                    },
                    {
                      "value": "thermafoliant_body_scrub",
                      "text": "thermafoliant body scrub"
                    },
                    {
                      "value": "ultracalming_cleanser",
                      "text": "ultracalming cleanser"
                    },
                    {
                      "value": "ultracalming_mist_toner",
                      "text": "ultracalming mist toner"
                    },
                    {
                      "value": "ultracalming_serum_concentrate",
                      "text": "ultracalming serum concentrate"
                    },
                    {
                      "value": "pro_collagen_banking_serum",
                      "text": "pro-collagen banking serum"
                    },
                    {
                      "value": "phyto_nature_oxygen_cream",
                      "text": "phyto nature oxygen cream"
                    },
                    {
                      "value": "prescreen_spf40",
                      "text": "porescreen spf40"
                    },
                    {
                      "value": "stabilizing_repair_cream",
                      "text": "stabilizing repair cream"
                    },
                    {
                      "value": "deep_breakout_patch",
                      "text": "deep breakout patch"
                    },
                    {
                      "value": "clarifying_body_spray",
                      "text": "clarifying body spray"
                    },
                    {
                      "value": "oil_to_foam_total_cleanser",
                      "text": "oil to foam total cleanser"
                    },
                    {
                      "value": "phyto_nature_lifting_eye_cream",
                      "text": "phyto nature lifting eye cream"
                    },
                    {
                      "value": "blc_night_restore",
                      "text": "biolumin-c night restore"
                    },
                    {
                      "value": "mvp_recovery_cream",
                      "text": "multivitamin power recovery cream"
                    },
                    {
                      "value": "dynamic_skin_strengthening_serum",
                      "text": "dynamic skin strengthening serum"
                    },
                    {
                      "value": "blc_heat_aging_protector",
                      "text": "biolumin-c heat aging protector spf50"
                    }
                  ]
                },
                {
                  "type": "text",
                  "name": "how_to_use",
                  "minWidth": "200px",
                  "title": "how to use",
                  "titleLocation": "left",
                  "defaultValueExpression": "iif({panel.product_name} = 'active_clay_cleanser', 'Massage onto dampened face and neck, rinse with warm water. Use daily.', \niif({panel.product_name} = 'active_moist_moisturizer', 'Apply over damp face and neck with light, upward strokes. Use twice daily.', \niif({panel.product_name} = 'age_bright_clearing_serum', 'Apply a thin layer and allow to dry. Use all over the face and under your moisturizer twice a day, as needed.', \niif({panel.product_name} = 'age_bright_spot_fader', 'Apply directly upon first sign of breakout and reapply twice a day until spot fades.', \niif({panel.product_name} = 'age_defense_kit', 'Use the products in the morning and evening as directed.', \niif({panel.product_name} = 'age_reversal_eye_complex', 'Start using alternate nights, for the first two weeks. As skin responds, build up to using nightly.', \niif({panel.product_name} = 'antioxidant_hydramist_toner', 'After cleansing, spritz directly onto face and neck, avoiding the eyes.', \niif({panel.product_name} = 'awaken_peptide_eye_gel', 'Apply under the eye and along the orbital bone morning and evening.', \niif({panel.product_name} = 'barrier_repair_serum', 'Apply a small amount to the face and neck.', \niif({panel.product_name} = 'biolumin-c_eye_serum', 'Apply under the eye and along the orbital bone morning and evening.', \niif({panel.product_name} = 'biolumin-c_gel_moisturizer', 'Smooth over cleansed face and neck morning and night.', \niif({panel.product_name} = 'biolumin-c_serum', 'Smooth over cleansed face and neck morning and night after toning and before moisturizing.', \niif({panel.product_name} = 'blackhead_clearing_fizz_mask', 'Apply to areas of congestion, massage gently and leave on for 3-5 minutes. Rinse thoroughly with warm water.', \niif({panel.product_name} = 'body_hydrating_cream', 'Smooth onto the body and massage until absorbed.', \niif({panel.product_name} = 'breakout_clearing_booster', 'Apply directly to blemish or breakout area, allow to dry. Use twice a day as needed.', \niif({panel.product_name} = 'breakout_clearing_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'breakout_clearing_liquid_peel', 'Apply a thin layer to clean skin, avoiding the eye area. Leave on for 3-5 minutes, then rinse thoroughly.', \niif({panel.product_name} = 'brightening_biolumin-c_trio_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'calm_water_gel_moisturizer', 'Squeeze a small amount into palm and rub hands together to activate. Pat gently onto face and neck.', \niif({panel.product_name} = 'charcoal_rescue_masque', 'Apply generously to face and throat, avoiding the eye area. After 7-10 minutes, lightly massage with very wet hands to enhance exfoliation during removal. Rinse thoroughly.', \niif({panel.product_name} = 'circular_hydration_serum', 'Smooth over cleansed face and neck morning and night after toning and before moisturizing.', \niif({panel.product_name} = 'clear_+_brighten_power_duo_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'clear_and_brighten_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'clearing_defense_spf30', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'clearing_skin_wash_cleanser', 'Work a pea-sized amount into a lather in wet hands. Apply to dampened face and rinse thoroughly with warm water.', \niif({panel.product_name} = 'conditioning_body_wash', 'Squeeze a small amount onto wet hands or sponge and work into a lather. Apply to wet skin and rinse.', \niif({panel.product_name} = 'cooling_aqua_jelly_moisturizer', 'Apply over face and neck after cleansing and toning.', \niif({panel.product_name} = 'daily_brightness_boosters_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'daily_glycolic_cleanser', 'Dispense into wet hands and create a creamy lather. Apply to damp face and neck, rinse thoroughly with warm water.', \niif({panel.product_name} = 'daily_microfoliant_exfoliator', 'Dispense about a half-teaspoon into very wet hands and create a creamy paste by rubbing hands together. Apply to face in circular motions, avoid the eye area. Massage gently for one minute, then rinse thoroughly with warm water.', \niif({panel.product_name} = 'daily_milkfoliant_exfoliator', 'Dispense into wet hands and create a creamy lather. Massage onto clean face. Rinse thoroughly.', \niif({panel.product_name} = 'daily_superfoliant_exfoliator', 'After cleansing, dispense a half-teaspoon into wet hands and create a creamy paste. Apply to face in circular motions, avoiding the eye area. Massage gently for one minute, then rinse thoroughly.', \niif({panel.product_name} = 'dark_spot_solutions_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'discover_healthy_skin_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'double_cleanse_+_go_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'double_cleanse_full_size_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'dynamic_skin_recovery_spf50_moisturizer', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'hyaluronic_ceramide_mist_toner', 'After cleansing, spritz directly onto face and neck, avoiding the eyes.', \niif({panel.product_name} = 'hydro_masque_exfoliant', 'Apply generously to cleansed face and neck, avoiding the eye area. After 3-5 minutes, massage in circular motions and rinse thoroughly.', \niif({panel.product_name} = 'intensive_eye_repair', 'Apply a small amount around the eye area, working from the outer corners inward.', \niif({panel.product_name} = 'intensive_moisture_balance_moisturizer', 'Apply over damp face and neck with light, upward strokes. Use twice daily.', \niif({panel.product_name} = 'intensive_moisture_cleanser', 'Massage onto dampened face and neck. Rinse thoroughly with warm water.', \niif({panel.product_name} = 'intensive_moisture_trio_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'invisible_physical_defense_spf30', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'melting_moisture_masque', 'Apply a generous amount to face and neck. Leave on for 3-5 minutes, then rinse thoroughly.', \niif({panel.product_name} = 'micro-pore_mist_toner', 'After cleansing, spritz directly onto face and neck, avoiding the eyes.', \niif({panel.product_name} = 'multi-active_toner', 'After cleansing, spritz directly onto face and neck, avoiding the eyes.', \niif({panel.product_name} = 'multi-masque_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'multivitamin_power_firm_eye_cream', 'Smooth around eyes, concentrating on areas of visible aging.', \niif({panel.product_name} = 'multivitamin_power_recovery_masque', 'Apply generously to cleansed face and throat, avoiding the eye area. After 10-15 minutes, rinse thoroughly.', \niif({panel.product_name} = 'multivitamin_power_serum', 'Smooth over cleansed face and neck morning and night after toning and before moisturizing.', \niif({panel.product_name} = 'multivitamin_thermafoliant_exfoliator', 'Massage gently onto clean face for one to two minutes, avoiding the eye area. Rinse thoroughly with warm water.', \niif({panel.product_name} = 'neck_fit_contour_serum', 'Turn applicator ON. Tilt chin up and roll applicator over entire neck, from the décolleté up to the jawline. Squeeze tube to dispense a thin layer of serum while rolling. Return applicator to OFF position and continue rolling it in an upward motion over skin to massage in the serum.', \niif({panel.product_name} = 'nightly_lip_treatment', 'After cleansing and toning, apply generously and massage into skin on and around the lip area.', \niif({panel.product_name} = 'oil_free_matte_spf30', 'Apply evenly and liberally to face, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'overnight_repair_serum', 'Press 4-6 drops onto skin and follow with prescribed Dermalogica Moisturizer.', \niif({panel.product_name} = 'overnight_retinol_repair', 'For best results, mix one part Overnight Retinol Repair with up to three parts Buffer Cream. Use nightly.', \niif({panel.product_name} = 'phyto_replenish_body_oil', 'Massage a few drops onto clean, dry skin.', \niif({panel.product_name} = 'phyto_replenish_oil', 'Press 4-6 drops onto skin and follow with prescribed Dermalogica Moisturizer.', \niif({panel.product_name} = 'phyto-nature_firming_serum', 'Dispense one to two pumps into palm of hand. Press into skin.', \niif({panel.product_name} = 'post-breakout_fix', 'Apply directly to blemish or breakout area, allow to dry. Use twice a day as needed.', \niif({panel.product_name} = 'powder_foliant_trio_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'powerbright_dark_spot_serum', 'Smooth over face after cleansing and toning, twice a day.', \niif({panel.product_name} = 'powerbright_moisturizer_spf50', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'powerbright_overnight_cream_moisturizer', 'Smooth over face and neck as the last step of your nighttime regimen.', \niif({panel.product_name} = 'precleanse_cleansing_balm', 'Apply to dry skin and massage in to melt away makeup and impurities. Rinse with water.', \niif({panel.product_name} = 'precleanse_cleansing_oil', 'Apply to dry face and eyes to dissolve surface oil and dirt. Concentrate on areas of congestion or stubborn debris. Wet hands and continue massaging to create a light, milky emulsion. Rinse with lukewarm water.', \niif({panel.product_name} = 'prisma_protect_spf30_moisturizer', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'protection_50_sport_spf50', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'rapid_reveal_peel', 'Twist open applicator plug and dispense product into hands. Lightly massage over face, neck and chest with fingertips in circular motion. Allow to activate for 3-7 minutes, depending on skin’s sensitivity.', \niif({panel.product_name} = 'redness_relief_essence', 'Shake well and dispense into palm. Pat gently onto cleansed face and neck.', \niif({panel.product_name} = 'renewal_lip_complex', 'Apply to lips at least two times a day for lip health maintenance.', \niif({panel.product_name} = 'retinol_clearing_oil', 'Press 4-6 drops onto skin and follow with prescribed Dermalogica Moisturizer.', \niif({panel.product_name} = 'sebum_clearing_masque', 'Apply a smooth layer to clean face and neck (avoiding the eye area) three times per week. May also be used exclusively on the T-zone. Leave on for 10 minutes, then rinse thoroughly with warm water.', \niif({panel.product_name} = 'sensitive_skin_rescue_kit', 'Use each product as directed within the kit instructions.', \niif({panel.product_name} = 'sheer_tint_spf20', 'Smooth over face and neck.', \niif({panel.product_name} = 'skin_hydrating_booster', 'Squeeze a small dose onto fingertips and massage gently over face and throat. Follow with moisturizer.', \niif({panel.product_name} = 'skin_hydrating_masque', 'Apply a smooth film to clean face and throat. After 10 minutes, rinse thoroughly.', \niif({panel.product_name} = 'skin_resurfacing_cleanser', 'Lightly lather in hands and apply to damp face and throat, avoiding the eye area. Massage with light, upward strokes for at least 30 seconds. Rinse thoroughly with warm water.', \niif({panel.product_name} = 'skin_smoothing_cream_moisturizer', 'Apply over damp face and neck with light, upward strokes. Use twice daily.', \niif({panel.product_name} = 'skin_soothing_hydrating_lotion_moisturizer', 'Apply a thin layer to cleansed face and neck.', \niif({panel.product_name} = 'skinperfect_primer_spf30', 'After applying prescribed Dermalogica Moisturizer, smooth and blend over entire face and throat.', \niif({panel.product_name} = 'smart_response_serum', 'Apply each morning after cleansing and toning.', \niif({panel.product_name} = 'sound_sleep_cocoon_moisturizer', 'Smooth over face and neck as the last step of your nighttime regimen.', \niif({panel.product_name} = 'special_cleansing_gel_cleanser', 'Gently lather a small amount in moistened hands and apply to dampened face and throat.', \niif({panel.product_name} = 'stress_positive_eye_lift_mask', 'Apply generously around eye area using cooling massage applicator. Leave on for 3-5 minutes. Massage any excess product into skin.', \niif({panel.product_name} = 'super_rich_repair_moisturizer', 'Apply to face and neck with light, upward strokes.', \niif({panel.product_name} = 'thermafoliant_body_scrub', 'Massage over wet skin using gentle circular motions, then rinse.', \niif({panel.product_name} = 'ultracalming_cleanser', 'Apply to dry or damp face and neck, and over closed eyes with circular motions.', \niif({panel.product_name} = 'ultracalming_mist_toner', 'After cleansing, spray directly over entire face and throat, with eyes closed.', \niif({panel.product_name} = 'ultracalming_serum_concentrate', 'Apply to face, neck and chest with light, upward strokes.', \niif({panel.product_name} = 'pro_collagen_banking_serum', 'Apply to cleansed face and neck in the evening.', \niif({panel.product_name} = 'phyto_nature_oxygen_cream', 'Apply to face and neck in the morning and evening.', \niif({panel.product_name} = 'prescreen_spf40', 'Apply a generous amount to face and neck, preferably 30 minutes prior to sun exposure.', \niif({panel.product_name} = 'stabilizing_repair_cream', 'Apply to affected area one to three times daily.', \niif({panel.product_name} = 'deep_breakout_patch', 'Apply a patch to the breakout area. Leave on for 8-10 hours, then remove.', \niif({panel.product_name} = 'clarifying_body_spray', 'Spray directly onto cleansed skin, focusing on areas of congestion.', \niif({panel.product_name} = 'oil_to_foam_total_cleanser', 'Massage onto damp skin until it foams. Rinse thoroughly.', \niif({panel.product_name} = 'phyto_nature_lifting_eye_cream', 'Gently apply a small amount around the eye area.', ''))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))"
                },
                {
                  "type": "panel",
                  "name": "regimen_schedule",
                  "showQuestionNumbers": "off",
                  "elements": [
                    {
                      "type": "checkbox",
                      "name": "schedule_ampm",
                      "minWidth": "200px",
                      "title": " ",
                      "titleLocation": "hidden",
                      "choices": [
                        {
                          "value": "am",
                          "text": "☼ am"
                        },
                        {
                          "value": "pm",
                          "text": "☽ pm"
                        }
                      ]
                    },
                    {
                      "type": "checkbox",
                      "name": "schedule_daily",
                      "minWidth": "200px",
                      "startWithNewLine": false,
                      "titleLocation": "hidden",
                      "choices": [
                        "daily"
                      ]
                    },
                    {
                      "type": "text",
                      "name": "schedule_times_a_week",
                      "minWidth": "200px",
                      "maxWidth": "100px",
                      "startWithNewLine": false,
                      "title": "times / week",
                      "titleLocation": "hidden",
                      "description": "times / week",
                      "descriptionLocation": "underInput",
                      "inputType": "number",
                      "step": 0
                    }
                  ]
                }
              ],
              "noEntriesText": "There are no products yet.\nClick the button below to add a new product.",
              "panelCount": 1,
              "minPanelCount": 1,
              "maxPanelCount": 15,
              "panelsState": "firstExpanded",
              "confirmDeleteText": "Do you want to delete the product?",
              "panelAddText": "add product",
              "panelRemoveText": "remove product",
              "showRangeInProgress": false,
              "showProgressBar": false
            },
            {
              "type": "paneldynamic",
              "name": "service",
              "state": "collapsed",
              "title": "Recommend a Service",
              "titleLocation": "top",
              "hideNumber": true,
              "templateElements": [
                {
                  "type": "dropdown",
                  "name": "service_select",
                  "visible": false,
                  "title": "Services",
                  "titleLocation": "left",
                  "choices": [
                    {
                      "value": "proskin",
                      "text": "pro skin treatment"
                    },
                    {
                      "value": "promicroneedling",
                      "text": "pro microneedling"
                    },
                    {
                      "value": "pronanoinfusion",
                      "text": "pro nanoinfusion"
                    },
                    {
                      "value": "propowerpeel",
                      "text": "pro power peel"
                    },
                    {
                      "value": "probright",
                      "text": "pro bright treatment"
                    },
                    {
                      "value": "procalm",
                      "text": "pro calm treatment"
                    },
                    {
                      "value": "proclear",
                      "text": "pro clear treatment"
                    },
                    {
                      "value": "profirm",
                      "text": "pro firm treatment"
                    },
                    {
                      "value": "clearglow",
                      "text": "clear start clear + glow"
                    },
                    {
                      "value": "proeyeflash",
                      "text": "pro eye flash"
                    },
                    {
                      "value": "luminfusion",
                      "text": "luminfusion"
                    },
                    {
                      "value": "exobooster",
                      "text": "exo booster"
                    }
                  ]
                },
                {
                  "type": "imagepicker",
                  "name": "service-select",
                  "title": "services",
                  "hideNumber": true,
                  "choices": [
                    {
                      "value": "pro skin",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=13b3789d-be7e-405a-bde4-a0b1bfaa6785"
                    },
                    {
                      "value": "pro microneedling",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=c287d2d5-68a4-4392-9e87-697d2b3b30d3"
                    },
                    {
                      "value": "pro nanoinfusion",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=bf97b721-64da-446c-9f23-8dca1a7d947c"
                    },
                    {
                      "value": "pro power peel",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=cd46060e-31e6-47b6-856a-d8c41b0b1886"
                    },
                    {
                      "value": "pro bright",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=50b459ac-92b0-4674-ae4c-ee5c290607c1"
                    },
                    {
                      "value": "pro calm",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=c4fc1f00-1182-417b-9a3c-a3575ec7f2a3"
                    },
                    {
                      "value": "pro clear",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=dae03bf1-9107-4db6-9644-f84f146dc053"
                    },
                    {
                      "value": "pro firm",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=6aec983f-67b9-4f53-89ae-e510376718ff"
                    },
                    {
                      "value": "clear start clear + glow",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=ca5fc1a0-6016-48ce-9514-e6626ff20751"
                    },
                    {
                      "value": "pro eye flash",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=27edbaab-ec8f-4e37-bd11-95d831130e19"
                    },
                    {
                      "value": "luminfusion",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=dd511a27-795a-4b05-8bc5-8138bdac81c2"
                    },
                    {
                      "value": "exobooster",
                      "text": "exo booster",
                      "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=1506d7c5-3c46-48d3-93c4-92c290c5c11d"
                    }
                  ],
                  "colCount": 5,
                  "imageFit": "cover",
                  "showLabel": true
                },
                {
                  "type": "html",
                  "name": "microneedling_desc",
                  "visibleIf": "{panel.service-select} = 'pro microneedling'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro microneedling procedure description:</span></h2>\n\nThis skin care procedure is designed to stimulate the skin with micro-injuries to induce the production of collagen and elastin and improve the appearance of the skin. It is designed for use by skin care professionals.\nThe procedure is performed in a safe and precise manner utilising a sterile Microneedling pen. The procedure is typically completed in 30- 60 minutes. The treatment time can vary based on the required treatment and anatomical site being treated."
                },
                {
                  "type": "html",
                  "name": "nanoinfusion_desc",
                  "visibleIf": "{panel.service-select} = 'pro nanoinfusion'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro nanoinfusion procedure description:</span></h2>\n\nNanoInfusion goes by various names such as\nMicroexfoliation, nanoinfusion or Nano exfoliation. It is a non-invasive procedure that involves the use of a pen style modality and nano-tips instead of needles. It uses very tiny cones formed of stainless steel that do not penetrate the skin, but do help with resurfacing and product infusion. This is an alternative treatment for clients who do not want any downtime or those who may be contraindicated to microneedling. It can also\nimprove skin texture, boost hydration and address signs of premature skin aging. The most immediate, visible change in the skin is a hydrated glow."
                },
                {
                  "type": "html",
                  "name": "propowerpeel_desc",
                  "visibleIf": "{panel.service-select} = 'pro power peel'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro power peel procedure description:</span></h2>\n\nThis skin care procedure is designed to accelerate skin rejuvenation through removal of the outer layers of the skin. \n<div>\nThe procedure is performed utilising chemical peel agents including hydroxy acids. The procedure is typically completed in 30 - 60 minutes. The treatment time can\nvary based on the required treatment and anatomical site being treated.\n</div>"
                },
                {
                  "type": "html",
                  "name": "proskin_desc",
                  "visibleIf": "{panel.service-select} = 'pro skin'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro skin procedure description:</span></h2>\n\nCompared to your typical facial, the Dermalogica Pro Skin treatment delivers so much more! Tailored to your skin’s needs on the day, your skin therapist will design your treatment to target your main skin concerns and include wellness touches to aid in relaxation and stress relief. Enhanced technologies such as microcurrent, ultrasonic and LED light therapy may be included alongside professional-grade formulas to deliver superior skin results. You will be left with radiant, glowing skin and feeling incredibly relaxed."
                },
                {
                  "type": "html",
                  "name": "probright_desc",
                  "visibleIf": "{panel.service-select} = 'pro bright'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro bright procedure description:</span></h2>\n\nFade dark spots and reveal brighter skin. This high-intensity treatment combines a brightening peel with an electric infusion of professional-grade Vitamin C, Niacinamide and Hexylresorcinol - addressing all pigmentation concerns."
                },
                {
                  "type": "html",
                  "name": "procalm_desc",
                  "visibleIf": "{panel.service-select} = 'pro calm'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro calm procedure description:</span></h2>\n\nSoothe and strengthen sensitive skin. Soothing botanical actives provide relief while lymphatic drainage and pressure point massage help calm a stressed nervous system. This targeted treatment helps hydrate, balance and restore the skin barrier for reduced sensitivity and calmer skin."
                },
                {
                  "type": "html",
                  "name": "proclear_desc",
                  "visibleIf": "{panel.service-select} = 'pro clear'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro clear procedure description:</span></h2>\n\nYour journey towards clear skin starts here. Pore softening techniques, extractions and anti-bacterial, microbiome-balancing actives work together to clear and calm congested breakout-prone skin."
                },
                {
                  "type": "html",
                  "name": "profirm_desc",
                  "visibleIf": "{panel.service-select} = 'pro firm'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro firm procedure description:</span></h2>\n\nA comprehensive facial workout including the neck. Includes a firming and toning facia massage or Gua Sha touch therapy to revive the skin. Firming techniques are combined with retexturing and replenishing actives for visibly tighter skin."
                },
                {
                  "type": "html",
                  "name": "clearglow_desc",
                  "visibleIf": "{panel.service-select} = 'clear start clear + glow'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">clear start clear + glow\n procedure description:</span></h2>\n\nFor teens and young adults, pro extractions clears congestion, breakouts are calmed, and skin is left glowing."
                },
                {
                  "type": "html",
                  "name": "eyeflash_desc",
                  "visibleIf": "{panel.service-select} = 'pro eye flash'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro eye flash\n procedure description:</span></h2>\n\nA powerful treatment that helps tone, smooth and brighten the eye area through intense stimulation and an infusion of botanical actives."
                },
                {
                  "type": "html",
                  "name": "luminfusion_desc",
                  "visibleIf": "{panel.service-select} = 'luminfusion'",
                  "html": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">luminfusion\n procedure description:</span></h2>\n\nLuminFusion combines a targeted Retinol Peel to resurface and renew, NanoInfusion technology to deeply infuse active ingredients and LED red light therapy to visibly restore skin luminosity & diminish signs of skin aging with no down time."
                },
                {
                  "type": "comment",
                  "name": "service_notes",
                  "visibleIf": "{panel.service-select} notempty",
                  "title": "Notes:"
                }
              ],
              "noEntriesText": "Click the button below to recommend a service.",
              "maxPanelCount": 1,
              "panelsState": "firstExpanded",
              "confirmDeleteText": "Do you want to delete the recommended service?",
              "panelAddText": "add recommendation",
              "panelRemoveText": "remove recommendation",
              "showRangeInProgress": false,
              "showProgressBar": false
            },
            {
              "type": "paneldynamic",
              "name": "skincareguide_panel",
              "indent": 1,
              "titleLocation": "hidden",
              "templateElements": [
                {
                  "type": "image",
                  "name": "skincareguide",
                  "indent": 1,
                  "hideNumber": true,
                  "imageLink": "https://api.surveyjs.io/private/Surveys/files?name=16301de8-f03f-425c-b9d0-3f1eea272726",
                  "contentMode": "image",
                  "imageFit": "fill"
                }
              ],
              "noEntriesText": "Click below to display the skin care guide.",
              "maxPanelCount": 1,
              "panelAddText": "show skin care guide",
              "panelRemoveText": "hide skin care guide",
              "showRangeInProgress": false,
              "showProgressBar": false
            }
          ]
        }
      ],
      "triggers": [
        {
          "type": "runexpression"
        }
      ],
      "showTitle": false,
      "showPageTitles": false,
      "completeText": "submit",
      "questionsOnPageMode": "singlePage",
      "widthMode": "responsive"
    }
    return json;
}






